import { ICardResponse } from "../../../services/api/banking/cards/types";

export const selectorCardName = (card: ICardResponse) =>
  card.isVirtualCard ? "virtual card" : "physical debit card";
